<template>
    <div  class="modal_design">
        <b-modal title="সার চার্জ মওকুফ" no-close-on-backdrop hide-footer size="l" v-model="largeModal" @ok="largeModal = false">
            <form  @submit.prevent="dueChargeOffBill()">
                <div class="form-group">
                    <label ><b>আপনি কি শিউর যে আপনি সার চার্জ মওকুফ করতে চান ? তাহলে আপনার গোপন পিন দিয়ে সাবমিট করুন। আপনি কোনোভাবেই আর আগের অবস্থায় যেতে পারবেন না ।</b></label>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label">সিক্রেট পিন <span class="required">*</span></label>
                    <div class="col-sm-8">
                        <input type="password" data-vv-as="'Secret Pin'" v-validate="'required'" name="secret_pin" v-model="data.secret_pin" placeholder="Enter Secret Pin" class="form-control">
                        <p v-show="errors.has('secret_pin')"  style="color:red">* This field is required</p>
                    </div>
                </div>
                <button type="submit" class="btn btn-primary">Submit</button>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "DueChargeOff",
        data(){
            return{
                data :{
                    secret_pin:'',
                    invoice_type:'',
                    skip:0,
                    pin:''
                },
                largeModal:false,
            }
        },

        methods:{
            dueChargeOffBill()
            {
                this.$validator.validateAll().then( result =>{
                    if(result){
                        if(this.data.secret_pin==this.data.pin){
                            this.addLoader = true;
                            this.$store.dispatch('DUECHARGE_OFF_INVOICE',this.data)
                            .then(response=>{
                                this.addLoader = false;
                                this.largeModal = false
                                this.$iziToast.success({position:'topRight',title:'Ok',message:"Invoice Updated Successsfully"})
                            })
                            .catch(error=>{
                                this.addLoader = false;
                                this.$iziToast.error({position:'topRight',title:'Error',message:"Something Wrong !!"})
                            });
                        }else{
                            this.addLoader = false;
                            this.$iziToast.error({position:'topRight',title:'Error',message:"Secret pin is wrong"})
                        }

                    }

                })
            },
            openModal(invoice,pin){
                this.data.invoice_type = invoice
                this.data.pin = pin
                this.data.secret_pin = ''
                this.largeModal = true;
            }
        }
    }
</script>

<style scoped>
    .modal_design{
        width: 300px;
        height: 100px;
    }
</style>